<template>
  <div id="app">
    <v-app>
      <v-app-bar app dense rounded v-if="is_login" clipped-left>
        <v-app-bar-nav-icon
          v-if="is_mobile"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
        <light-modes :persist_config="true"></light-modes>
        <div v-if="is_login">
          <v-menu offset-y rounded="lg" v-model="menu_p">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="ma-0 pa-0" v-bind="attrs" v-on="on" elevation="0">
                <v-img
                  class="d-md-none"
                  :src="require(`@/assets/Proteryx-05-small-c.png`)"
                  width="62px"
                ></v-img>
                <v-img
                  class="d-none d-md-block"
                  :src="require(`@/assets/Proteryx-07-350-c.png`)"
                  width="150px"
                ></v-img>

                <v-icon>{{ btn_action }}</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item>
                <v-list-item-content class="text-left">
                  <v-btn elevation="0" disabled>
                    <v-img
                      :src="require(`@/assets/Proteryx_FAM-c.png`)"
                      width="150px"
                    ></v-img>
                  </v-btn>
                </v-list-item-content>
                <v-list-item-action class="text-caption rounded-pill">
                  coming soon
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
            </v-list>
          </v-menu>
        </div>

        <div v-if="!is_mobile">
          <div v-if="!drawer">
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  @click.stop="drawer = !drawer"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-img
                    :src="require(`@/assets/open_sidebar_proteryx.svg`)"
                  ></v-img>
                </v-btn>
              </template>
              <span>Open sidebar</span>
            </v-tooltip>
          </div>
          <div v-else>
            <v-tooltip right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  @click.stop="drawer = !drawer"
                  elevation="0"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-img
                    :src="require(`@/assets/close_sidebar_proteryx.svg`)"
                  ></v-img>
                </v-btn>
              </template>
              <span>Close sidebar</span>
            </v-tooltip>
          </div>
        </div>
        <div id="tp-app-bar-start"></div>
        <v-spacer></v-spacer>
        <div id="tp-app-bar-middle"></div>
        <v-spacer></v-spacer>
        <div id="tp-app-bar-last" class="mr-1"></div>
        <div v-show="debug && token_alives != null">
          {{ ST.timeFormat(token_alives) }}
        </div>
        <div class="mr-1">
          <v-btn
            small
            elevation="0"
            color="primary"
            class="text-none"
            :to="{ name: 'terminal' }"
          >
            <v-img
              :src="require(`@/assets/new_trade_p.svg`)"
              class="mr-1"
            ></v-img>
            <span class="d-none d-md-block">New trade</span>
          </v-btn>
        </div>
        <drop-down-profile-menu></drop-down-profile-menu>
      </v-app-bar>
      <LoginUser
        ref="login_user"
        v-show="false"
        :token_setter="true"
      ></LoginUser>
      <v-navigation-drawer
        ref="n-drawer"
        v-if="is_login && drawer"
        v-model="drawer"
        class="mt-13"
        app
        :absolute="!is_mobile"
        :permanent="!is_mobile"
        :expand-on-hover="!is_mobile"
        :mini-variant.sync="mini"
        :temporary="is_mobile"
      >
        <v-list dense v-if="!requires_profile_data">
          <v-list-item v-for="item in menues" :key="item.title" :to="item.link">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-list dense v-if="!requires_profile_data">
          <v-list-item
            ><v-subheader class="overflow-hidden"
              >TRADING</v-subheader
            ></v-list-item
          >
          <v-list-item
            v-for="item in trading_menues_allowed"
            :key="item.title"
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> {{ item.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action v-if="item.title_right"
              ><span class="text-caption primary--text text--lighten-1">{{
                item.title_right
              }}</span></v-list-item-action
            >
          </v-list-item>
          <v-list-item
            ><v-subheader class="overflow-hidden"
              >OTHER</v-subheader
            ></v-list-item
          >

          <v-list-item href="https://help.proteryx.com/en" target="_blank">
            <v-list-item-icon>
              <v-icon>mdi-text-box-search-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Documentation</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            href="https://proteryx.features.vote/roadmap"
            target="_blank"
          >
            <v-list-item-icon>
              <v-icon>mdi-hand-back-left-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>Feature Request</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            v-for="item in other_menues"
            :key="item.title"
            :to="item.link"
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title> {{ item.title }}</v-list-item-title>
            </v-list-item-content>
            <v-list-item-action
              v-if="item.title_right"
              :class="item.title_right.class"
              :style="item.title_right.style"
              >{{ item.title_right.text }}</v-list-item-action
            >
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
      <v-main>
        <LoadOverlay :activate="!is_ready"></LoadOverlay>

        <router-view></router-view>
      </v-main>

      <v-footer app>
        <!-- <v-container> </v-container> -->
      </v-footer>
    </v-app>
  </div>
</template>

<script>
import Vuex from "vuex";

import LoadOverlay from "@/components/helpers/LoadOverlay.vue";
import LoginUser from "@/components/LoginUser.vue";
import DropDownProfileMenu from "@/components/profile/DropDownProfileMenu.vue";
import appMethods from "@/mixins/appMethods";
import LightModes from "@/components/helpers/LightModes.vue";

export default {
  name: "App",
  components: {
    LoginUser,
    LoadOverlay,
    DropDownProfileMenu,
    LightModes,
  },
  mixins: [appMethods],
  data: () => ({
    mini: true,
    menu_p: false,
    drawer: true,
    errors: null,
    menues: [
      {
        title: "Dashboard",
        icon: "mdi-view-dashboard-outline",
        link: "/dashboard",
      },
      {
        title: "Macro View",
        icon: "mdi-table-headers-eye",
        link: "/macro-view",
      },
      // {
      //   title: "Profile",
      //   icon: "mdi-account-box-multiple",
      //   link: "/profiles",
      //   any_permission: ["user:read"],
      // },

      // {
      //   title: "Signals",
      //   icon: "mdi-message-fast",
      //   link: "/stack-signals",
      //   any_permission: ["user:read"],
      // },
      // {
      //   title: "Brokers",
      //   icon: "mdi-server",
      //   link: "/node-brokers",
      //   any_permission: ["user:read"],
      // },
      // {
      //   title: "Linking",
      //   icon: "mdi-network",
      //   link: "/notify-linking",
      //   any_permission: ["user:read"],
      // },
      {
        title: "Brokers",
        icon: "mdi-briefcase-eye-outline",
        link: "/linking",
        any_permission: ["user:read"],
      },
      // { title: "Configs", icon: "mdi-cog", link: "/configs" },
      // { title: "Memberships", icon: "mdi-cog", link: "/memberships" },
      // { title: "About", icon: "mdi-information", link: "/about" },
    ],
    trading_menues: [
      {
        title: "Automations",
        title_right: null,
        icon: "mdi-robot-outline",
        link: "/signals-pro",
        any_permission: ["strategy:read"],
      },
      {
        title: "Automations NEW",
        title_right: null,
        icon: "mdi-robot-outline",
        link: "/automations",
        any_permission: ["auto-trader:publish"],
      },
      {
        title: "TradeDesk",
        title_right: null,
        icon: "mdi-laptop",
        link: "/terminal",
        any_permission: ["user-data-profile:read"],
      },
      {
        title: "Marketplace",
        title_right: null,
        icon: "mdi-storefront-plus-outline",
        link: "/marketplace",
        any_permission: ["user-data-profile:read"],
      },
    ],
    other_menues: [
      {
        title: "FAQ",
        title_right: null,
        icon: "mdi-folder-question-outline",
        link: "/faq",
        any_permission: ["user:read"],
      },
      {
        title: "Subscription",
        icon: "mdi-credit-card-sync-outline",
        title_right: {
          class:
            "px-2 text-caption white--text text--lighten-1 rounded-pill b-orange",
          style: "background: #F44336;",
          text: "SALE",
        },

        link: {
          name: "billing",
        },
        any_permission: ["user:read"],
      },
    ],
    token_alives: null,
    check_token_interval: null,
    debug: false,
  }),
  methods: {
    config_n_drawer(is_mobile) {
      if (is_mobile) {
        this.drawer = false;
        this.mini = false;
        if (this.$refs["n-drawer"])
          this.$refs["n-drawer"]["mini-variant"] = null;
      } else {
        this.drawer = true;
        this.mini = true;
        if (this.$refs["n-drawer"])
          this.$refs["n-drawer"]["mini-variant"] = this.mini;
      }
    },
  },
  watch: {
    async is_login(nval) {
      if (nval) {
        this.check_token_expiry();
        let profile = await this.get_and_set_profile_data();
        let schema = await this.fetch_schema_profiles(null);
        await this.get_and_set_preferences_data();
        await this.check_for_profile_data(schema, profile);
        await this.get_and_set_pulse_counters();
      } else {
        this.set_requires_profile_data(false);
      }
    },
    is_mobile(nval) {
      this.config_n_drawer(nval);
    },
  },
  computed: {
    is_mobile() {
      return this.$vuetify.breakpoint.width < 760;
    },
    btn_action() {
      if (this.menu) return "mdi-chevron-up";
      else return "mdi-chevron-down";
    },
    trading_menues_allowed() {
      return this.trading_menues.filter((m) =>
        this.has_any_permission(m.any_permission)
      );
    },
    ...Vuex.mapGetters(["has_any_permission"]),
  },
  mounted() {
    this.config_n_drawer(this.is_mobile);
  },
};
</script>
<style></style>
